import { ActionTree } from 'vuex';
import { fetchPosts } from '@/api';
import { RootState } from '../types';
import { StoreActions, StoreMutations } from '@/templates/DataNames';
import { cropTree, removeReact } from '@/heplers';
import { AxiosError } from 'axios';

export let fullContent = {};

export const actions: ActionTree<RootState, RootState> = {
  [StoreActions.TREE]: async ({ commit }): Promise<any> => {
    const url = `getTree`;

    try {
      const response = await fetchPosts(url);
      let tree = removeReact(response.data);
      tree = cropTree(tree);

      commit(StoreMutations.TREE, tree);
    } catch (error) {
      console.error('Failed to fetch and process tree data');
    }
  },

  [StoreActions.SEARCH]: async ({ commit }, data: string): Promise<any> => {
    const url = `searchDoc${data.trim()}`;

    const response = await fetchPosts(url);
    commit(StoreMutations.SEARCH, response.data);
  },

  [StoreActions.CONTENT]: async ({ state, commit }, props): Promise<any> => {
    const p = props
      ? '?' +
        Object.entries(props)
          .map((pair) => pair.join('='))
          .join('&')
      : '';
    const url = `getDoc${p}`;

    state.contentLoading = true;

    try {
      const response = await fetchPosts(url);
      fullContent = removeReact(response.data);
      commit(StoreMutations.CONTENT, fullContent);
    } catch (error) {
      if ((error as AxiosError).response?.data?.status === 404) {
        state.notFound = true;
      }
    }
  },
};
